import { useEffect } from "react";
import { useGlobals } from "@/components/providers/globals-provider.tsx";
import useScrollToRef from "@/features/sub-families/hooks/use-scroll-to-ref.ts";

export default function useFilterOptionScroll<T extends HTMLElement>(productProperty: string) {
    const { property } = useGlobals();

    const { ref, scrollToElement } = useScrollToRef<T>();

    useEffect(() => {
        if (!property || property !== productProperty) return;

        scrollToElement();
    }, [productProperty, property, ref, scrollToElement]);

    return ref;
}
